import { assign, groupBy } from 'lodash';
import { ActionType } from '../actions/actions';
import { IAAPDEvent } from '../../classes/event';
import { IAction } from '../../classes/action';
import * as Moment from 'moment';

export interface CalendarApiModel {
    /**
    * if this is true, events are currently being loaded
    */
    requestingEvents: boolean;
    /**
    *Replace with media response interface
    */
    eventList: any[];
    filteredEventList: any[];
    selectedCategory: string;
    
    /**
    *If there is no more events in the API, this will be set to true
    */
    noMoreEvents: boolean;
    currentBatch: number;
    selectedDate: Moment.Moment;
    selectedView: string;
    noEvents: boolean;
};

export const defaultCalendarApiModel: CalendarApiModel = {
    requestingEvents: false,
    eventList: [],
    filteredEventList: [],
    currentBatch: 0,
    noMoreEvents: false,
    selectedDate: Moment(),
    selectedCategory: "aapdcecourses",
    selectedView: "grid-view",
    noEvents: false
};


export default function calendarApiReducer(state: CalendarApiModel = defaultCalendarApiModel, action: IAction) {
    switch (action.type) {
        case ActionType.REQUEST_NEXT_BATCH: {
            return assign({}, state, { requestingEvents: true, currentBatch: state.currentBatch + 1 });
        }

        case ActionType.RECEIVE_NEXT_BATCH: {
            const events = action.value.events;
            const noMoreToLoad = action.value.noMoreEvents;
            
            const groupedArray = groupBy(events, (event) => {
                const momentObj = Moment(event.startDateTime);
                const eventKey = (momentObj.date().toString());
                return eventKey;
            });
            const noEvents = Object.keys(groupedArray).length == 0 ? true : false;
            let days = [];
            for (var i = 1; i <= state.selectedDate.daysInMonth(); i++) {
              var pushed = false;
              for (var day in groupedArray) {
                if (day == i.toString()) {
                  if (groupedArray.hasOwnProperty(day)) {

                    var obj = groupedArray[day];
                    days.push(obj);
                    pushed = true;
                    break;
                  }
                }
              }
              if (!pushed) {
                days.push([]);
                pushed = true;
              }

            }

            return assign({}, state, { requestingEvents: false, eventList: days, noMoreEvents: noMoreToLoad, noEvents: noEvents }) as CalendarApiModel
        }

        case ActionType.DECREMENT_MONTH: {
            return assign({}, state, { selectedDate: state.selectedDate.clone().subtract(1, 'M') })
        }

        case ActionType.INCREMENT_MONTH: {
            return assign({}, state, { selectedDate: state.selectedDate.clone().add(1, 'M') })
        }

        case ActionType.FILTER_EVENTS: {
            const category = action.value;
            return assign({}, state, { selectedCategory: category })
        }

        case ActionType.TOGGLE_VIEW: {
            const view = action.value;
            return assign({}, state, { selectedView: view })
        }

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/calendar/redux/reducers/calendar-api.ts